
import './App.css';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Navbar from "./Components/Navbar/Navbar"
import { Home } from './Pages/Home/Home';
import AOS from 'aos';
import React, { useState, useEffect } from 'react';
import { UniLoder } from './Components/Loder/UniLoder';
import 'aos/dist/aos.css';
import { FaInstagram } from 'react-icons/fa';


import 'react-toastify/dist/ReactToastify.css';
import ImageUpload from './Components/Image/ImageUpload';
import { Imageshare } from './Components/Image/Imageshare';
import LoginPage from './Components/Loginp/LoginPage';
import LockedPage from './Components/LockedPage/LockedPage';
import CommentPusher from './Comments/CommentPusher';
import Edit from './Components/Image/Edit/Edit';
import Load from './Components/Loder/Load';
import { ToastContainer } from 'react-toastify';
import Campaign from './Components/Campaign/Campaign';
import FooterWebsiteLink from './Components/Footer/FooterWebsiteLink';
function App() {

  const [loading, setLoading] = useState(true);


  useEffect(() => {
    AOS.init({
      duration: 4000,
      easing: 'ease',
    });
    AOS.refresh();

    fetchData(); 
  }, []);
  const fetchData = async () => {
    try {
      
      await new Promise((resolve) => setTimeout(resolve, 1000)); 
      
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false); 
    }
  };

  
  return (
    <div className="App">
 {loading ? (
        <Load/>
      ) : (
        <>
   <ToastContainer/>
      <Routes>
           
            <Route exact path="/loder" element={<UniLoder />} />
          
      
          
            <Route exact path="/:id" element={<Imageshare/>} />
            <Route exact path="k/:id" element={<Campaign/>} />

            <Route exact path="/admin" element={<LoginPage/>} />
        
            <Route exact path="/edit/:id" element={<Edit/>} />
            <Route exact path="/up" element={<ImageUpload/>} />




             </Routes>
           
            </>
             )}
           <FooterWebsiteLink/>
    </div>
  );
}

export default App;
